var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMessageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45192 9.18943V7.04362H1.06731C0.883696 7.04362 0.707605 6.96555 0.577772 6.82659C0.447939 6.68764 0.375 6.49917 0.375 6.30266V1.11596C0.375 0.919443 0.447939 0.730978 0.577772 0.592022C0.707605 0.453065 0.883696 0.375 1.06731 0.375H8.68269C8.8663 0.375 9.0424 0.453065 9.17223 0.592022C9.30206 0.730978 9.375 0.919443 9.375 1.11596V6.30266C9.375 6.49917 9.30206 6.68764 9.17223 6.82659C9.0424 6.96555 8.8663 7.04362 8.68269 7.04362H4.875L2.74754 9.32058C2.72333 9.34655 2.69247 9.36425 2.65885 9.37142C2.62524 9.3786 2.59039 9.37493 2.55872 9.36088C2.52706 9.34683 2.50001 9.32304 2.48099 9.29252C2.46198 9.26199 2.45186 9.22611 2.45192 9.18943Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45312 4.81662H7.29928M2.45312 2.59375H7.29928",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMessageIcon);
export default __webpack_public_path__ + "static/media/white_Message_Icon.595dc37266cd16c251dea025b7294d63.svg";
export { ForwardRef as ReactComponent };